import { createReducer, on } from '@ngrx/store';
import { JobsActions } from './jobs.actions';
import { Job } from '../../class/job.class';
import { TaskModel } from '../../models/task.model';
import { StatusEnum } from '../../enums/status.enum';
import { TaskEnum } from '../../enums/task.enum';
import { Task } from '../../class/task.class';
import { updateJobsFromWsMessage } from '../../helpers/job.helper';

export const initialState: ReadonlyArray<Job> = [];

function sortTasks(tasks: TaskModel[]): TaskModel[] {
  return [...tasks].sort((a: TaskModel, b: TaskModel) => a.type - b.type);
}

export const JobsReducer = createReducer(
  initialState,
  on(JobsActions.removeJob, (state, { jobId }) =>
    state.filter((job: Job) => job.id !== jobId)
  ),
  on(JobsActions.addJob, (state, { job }) => {
    if (state.some((j: Job) => j.id === job.id)) return state;
    return [...state, job];
  }),
  on(JobsActions.addJobs, (state, { jobs }) => {
    const sortedJobs = jobs.map(job => new Job({
      ...job.data,
      tasks: sortTasks(job.data.tasks)
    }));
    return [...state, ...sortedJobs];
  }),
  on(JobsActions.sortJobs, (state, { sortType }) => {
    const sortedJobs = [...state].sort((a: Job, b: Job) => {
      switch (sortType) {
        case 'created_at':
          return new Date(b.data.created_at).getTime() - new Date(a.data.created_at).getTime();
        case 'status':
          return a.status.localeCompare(b.status);
        case 'task':
          return a.data.tasks[a.data.tasks.length - 1].type - b.data.tasks[b.data.tasks.length - 1].type;
        default:
          return 0;
      }
    });
    return [...sortedJobs];
  }),
  on(JobsActions.updateJobFromWsMessage, (state, { wsUpdateTaskMessage }) => {
    return updateJobsFromWsMessage([...state], wsUpdateTaskMessage);
  })
);